import { __rest } from 'tslib';
import React from 'react';
import AntSpace from 'antd-core/es/space';
import { Root } from './styled.js';

AntSpace.Compact.displayName = 'Space.Compact';
const InnerSpace = React.forwardRef((_a, ref) => {
    var { grow, fullWidth } = _a, props = __rest(_a, ["grow", "fullWidth"]);
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-space' }, props, { ref: ref, "$grow": grow, "$fullWidth": fullWidth })));
});
const Space = Object.assign(InnerSpace, {
    displayName: 'Space',
    Compact: AntSpace.Compact,
});

export { Space };
//# sourceMappingURL=Space.js.map
